import React from 'react';
import { Link } from 'react-router-dom';

const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);

export default function BookingCard({ booking }) {
  const photo = (booking.photos && booking.photos[0]) || `https://placehold.co/640x360/0a1a2e/ffffff?text=${encodeURIComponent(booking.make + ' ' + booking.model)}`;
  return (
    <Link to={`/bookings/${booking._id}`} className="booking-card">
      <div className="booking-photo" style={{ backgroundImage: `url(${photo})` }} />
      <div className="booking-body">
        <div className="booking-title">{booking.year} {booking.make} {booking.model}</div>
        <div className="booking-meta">{(booking.mileage || 0).toLocaleString()} mi · {booking.bodyStyle} · {booking.fuelType}</div>
        <div className="booking-price">{fmt(booking.price)}</div>
      </div>
    </Link>
  );
}
